import React, { useEffect, useState } from "react";
import Breadcrumb from "../../Component/Breadcrumb";
import Loader from "../../Component/Loader";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

const PrivacyPolicy = () => {
  const navigate = useNavigate();

  const [privacyPolicyData, setPrivacyPolicyData] = useState();
  const [loading, setLoading] = useState(true);

  const callPrivacyPolicyApi = async () => {
    setLoading(true);
    const ipAddress = localStorage.getItem("ipaddress");
    const token = localStorage.getItem("token");

    await fetch(
      `${process.env.REACT_APP_API_URL}getprivacypolicy?clientId=${process.env.REACT_APP_Client_Id}&ipAddress=${ipAddress}`,

      {
        method: "GET",

        headers: {
          Authorization: `Token ${token}`,

          // "Content-Type": "application/json",
        },
      }
    )
      .then((response) => response.json())
      .then((data) => {
        if (
          data &&
          (data.detail === "The Token is expired" ||
            data.message === "Invalid token")
        ) {
          localStorage.clear();
          navigate("/logout");
        }
        if (data && data.status) {
          setPrivacyPolicyData(data?.privacyPolicyContentList?.[0]);

          setLoading(false);
        }
      })
      .catch((error) => {
        setLoading(false);
        toast.error("There was an error, Please try again later.");
      });
  };

  useEffect(() => {
    callPrivacyPolicyApi();
  }, []);

  if (loading) {
    <Loader />;
  }
  return (
    <>
      {" "}
      <Breadcrumb
        mainTitle={"Privacy Policy"}
        title={"Privacy Policy"}
        subTitle={"Home"}
      />
      <section class="section-content content-pages">
        <div class="container">
          <div class="row">
            <div class="col-12">
              <div class="rte">
                <p
                  data-aos="zoom-in-left"
                  style={{ marginBottom: 25, marginTop: 25 }}
                  className="aos-init"
                  dangerouslySetInnerHTML={{
                    __html: JSON.parse(
                      privacyPolicyData?.privacyPolicyContent || '""'
                    ),
                  }}
                ></p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default PrivacyPolicy;
